import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { ReactComponent as EmptySvg } from '../../../assets/empty_search_state.svg';
import { colorPalette, spacings, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';
import { emptySearchMessage, emptySearchTitle } from './EmptySearchState';

export const EmptySearchStateSlate = React.memo(
  (): React.ReactElement => {
    const classes = useStyles();
    return (
      <div className={classes.root}>
        <EmptySvg className={classes.icon} />
        <PlexTypography className={classes.title} text={emptySearchTitle} size={TextSizesEnum.XLarge} />
        <PlexTypography className={classes.message} text={emptySearchMessage} size={TextSizesEnum.NormalPlus} />
      </div>
    );
  }
);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacings.small,
    width: '100%',
    alignItems: 'center',
  },
  icon: {
    height: 120,
  },
  title: {
    color: '#464663',
    fontWeight: 'bold',
    marginTop: spacings.xlarge,
  },
  message: {
    color: colorPalette.purpleGray._500,
    marginTop: spacings.xlarge,
    marginBottom: spacings.xlarge,
    textAlign: 'center',
  },
}));
